import { render } from "./selfLessonDetail.vue?vue&type=template&id=7a7c4c7e&scoped=true"
import script from "./selfLessonDetail.vue?vue&type=script&lang=js"
export * from "./selfLessonDetail.vue?vue&type=script&lang=js"

import "./selfLessonDetail.vue?vue&type=style&index=0&id=7a7c4c7e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7c4c7e"]])

export default __exports__